// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inline-list{display:inline;word-break:break-word}.inline-list>*{display:inline;margin:0 5px 5px 0}.inline-list>*:last-child{margin:0 0 5px 0}", ""]);
// Exports
module.exports = exports;
